export default __webpack_public_path__ + "static/media/5.fc51c3ec.png";